export const isLocal = () =>
  process.env.NEXT_PUBLIC_MODE === "dev" &&
  process.env.NEXT_PUBLIC_LOCAL_MODE === "true";
